import { UserActivityObject } from "./Interfaces/UserActivityObject";

export const isLastSavedTimeNotGreaterThanOneHour = (lastUpdatedByUser: string | undefined | null): boolean => {
    const lastSavedTime = lastUpdatedByUser?.split('-%')[1];

    if (lastSavedTime) {
        const lastSavedTimeStamp = new Date(lastSavedTime);
        const currentDate = new Date();
        const diffInMinutes = (currentDate.getTime() - lastSavedTimeStamp.getTime()) / (1000 * 60);

        return diffInMinutes < 15 ;
    }

    return false;
};


export const createUserActivityTemplate = (user: string, currentSelectedSheet: any): UserActivityObject|undefined => {
    try {
        
        const isOwner = (user === currentSelectedSheet?.user_email);
        return {
            user_email: user,
            last_accessed_sheet: currentSelectedSheet?.sheet_identifier,
            is_owner: isOwner
        }
    } catch (error) {
        console.log("Error in createUserActivityTemplate", error);
        return undefined;
    }
}